<div [formGroup]="dadosGeraisGroup">
  <div class="row">
    <!-- Fornecedor -->
    <div class="col-12 col-md-4">
      <app-select-pesquisavel [control]="idFornecedorControl" [apiUrl]="urlFornecedor" label="Fornecedor" idField="id"
        nameField="descricao" [isOptional]="false">
      </app-select-pesquisavel>
    </div>

    <!-- Data Emissao -->
    <div class="col-12 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data de Emissão</mat-label>
        <input matInput [matDatepicker]="pickerEmissao" formControlName="dataEmissao" (input)="onDateInput($event, 'dataEmissao')" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerEmissao"></mat-datepicker-toggle>
        <mat-datepicker #pickerEmissao></mat-datepicker>
        @if (dadosGeraisGroup.get('dataEmissao')?.invalid) {
        <mat-error>Data inválida ou em branco</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Data Competencia -->
    <div class="col-12 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data de Competência</mat-label>
        <input matInput [matDatepicker]="pickerCompetencia" formControlName="dataCompetencia"
          (input)="onDateInput($event, 'dataCompetencia')" />
        <mat-datepicker-toggle matIconSuffix [for]="pickerCompetencia"></mat-datepicker-toggle>
        <mat-datepicker #pickerCompetencia></mat-datepicker>
        @if (dadosGeraisGroup.get('dataCompetencia')?.invalid) {
        <mat-error>Obrigatório</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Valor Total -->
    <div class="col-12 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor Total</mat-label>
        <input matInput formControlName="valorTotal" [currencyMask]="currencyMask" />
        @if (dadosGeraisGroup.get('valorTotal')?.hasError('required')) {
        <mat-error>Obrigatório</mat-error>
        } @else if (dadosGeraisGroup.get('valorTotal')?.hasError('min')) {
        <mat-error>O valor deve ser maior que zero</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Categoria Financeira -->
    <div class="col-12 col-md-4">
      @if (listaCategoriasFinanceiras.length > 0) {
      <app-select-pesquisavel [control]="idCategoriaFinanceiraControl" [offlineList]="listaCategoriasFinanceiras"
        label="Categoria Financeira" idField="idCategoriaFinanceira" nameField="descricao" [isOptional]="false">
      </app-select-pesquisavel>
      }
    </div>

    <!-- Número do Documento -->
    <div class="col-12 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Número do Documento</mat-label>
        <input matInput formControlName="numeroDocumento" maxlength="50" />
      </mat-form-field>
    </div>

    <!-- Descrição -->
    <div class="col-12 col-md-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Descrição do Lançamento</mat-label>
        <input matInput formControlName="descricao" maxlength="255" />
        @if (dadosGeraisGroup.get('descricao')?.invalid) {
        <mat-error>Obrigatório</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>